define('ordersDetailView',[
  'app',
  'module',
  'underscore',
  'headerFooterView',
  'modalsAlertView',
  'ordersDetailHeaderView',
  'ordersDetailBodyView',
  'compuzzProUtils',
  'windows',
  'entities/orders'
], function (
  App,
  Module,
  _,
  HeaderFooterView,
  AlertView,
  HeaderView,
  BodyView,
  CompuzzProUtils,
  Windows
) {
  'use strict';

  Module.exports = HeaderFooterView.extend({
    className: 'orders-detail-view ' + HeaderFooterView.prototype.className,
    childHeaderView: HeaderView,
    childView: BodyView,

    initialize: function () {    
      this.options.customer = this.model.get('customer');
      HeaderFooterView.prototype.initialize.call(this); 

      this.view.on('selected', _.bind(function () {  
        Windows.setNavigation();
      }, this));
    },

    onRender: function () {     
      if (this.isDestroyed)
        return;    

      this.listenTo(this.model.get('order'), 'deleted', _.bind(function() {
        this.orderDeleted();
      }, this));

      this.listenTo(this.model.get('order'), 'change', _.bind(function (model) {
        if (model.hasChanged('endUserId'))
          this.render();
      }, this));

      CompuzzProUtils.getInstance().addListener(this.bodyView, CompuzzProUtils.events.COMPUZZ_PRO_REFRESH_CUSTOM_PROOFSHEET,
      _.bind(function () {
        this.model.fetch(true);
      }, this));

      HeaderFooterView.prototype.onRender.call(this);    
    },

    orderDeleted: function () {
      AlertView.prototype.open('', _.i18n('common.orders.orderDeleted'), _.bind(function () {
        this.windowView.close();
      }, this));
    },

    onWindowClose: function() {
      require([
        'contentShowController',
        'ordersBoardView',
        'itemPagesNameMixin'
      ], _.bind(function (ContentShowController, View, ItemPagesNameMixin) {
        var currentView = App.regions.getRegion('main').currentView.getRegion('content').currentView;
        if (!currentView) {
          ContentShowController.showContent(false).done(_.bind(function () {
            var orderType = null;
            if(this.view)
              orderType = this.view.model.get('order').get('commandType');
            
            if(orderType) {
              var view = new View({
                parentStatus: null,
                endUserId: null,
                type: orderType
              });

              App.regions.getRegion('main').currentView.getRegion('content').show(view);

              if(orderType === 'offer')
                App.execute('set:active:nav:item', ItemPagesNameMixin.OFFERS_BOARD);
              else
                App.execute('set:active:nav:item', ItemPagesNameMixin.ORDERS_BOARD);
            }
          }, this));
        }
      }, this));
    },

    // Static methods
    open: function (poi, tabName) {
      require([
        'windows',
        'ordersDetailView'
      ], function (Windows, View) {    
        Windows.open({
          view: _.bind(function () {
            var defer = $.Deferred(); 
            var model = App.request('order-view:model');
            model.set('poi', poi, {silent: true});
            model.fetch(true).done(_.bind(function () {
              var customer = App.request('customers:entity:end-user-id', model.get('order').get('endUserId'));
              customer.fetch().done(_.bind(function() {
                model.set('customer', customer, {silent: true});
                defer.resolve(new View({
                  model: model,
                  tabName: tabName
                }));
              }, this));
            }, this));
            return defer.promise();
          }, this),     
          navigation: _.bind(function (windowView, view) {
            var defer = $.Deferred(); 
            if(view) {
              var uri = 'orders/' + view.model.get('poi');            
              var tab = view.view.getSelected();
              if (tab && tab.get('url') !== '')             
                uri += '/' + tab.get('url');          
              defer.resolve(uri);
            }
            return defer.promise();
          }, this),      
          id: 'order-detail:' + poi,
          className: 'orders-detail-window',
          title: _.i18n('order.detail.title') + ' | ' + poi,
          width: '98%',
          height: '98%'
        });   
      });
    }
  });
});

